/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'camps',
        title: 'Camps',
        type: 'collapsable',
        icon: 'heroicons_outline:home-modern',
        children: [
            {
                id: 'camps.camp-list',
                title: 'Camp list',
                subtitle: 'All camps and batches',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/camps',
            },
            {
                id: 'camp-category',
                title: 'Camp Category',
                subtitle: 'Group camps by type',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/camp-category',
            },
            {
                id: 'train',
                title: 'Trains',
                subtitle: 'Travel schedules',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/trains',
            },
            {
                id: 'additional-fees',
                title: 'Additional Camps Fees',
                subtitle: 'Extra charges per camp',
                type: 'basic',
                icon: 'heroicons_outline:currency-rupee',
                link: '/additional-fees',
            },
            {
                id: 'camps.camp-registrations',
                title: 'Camp Registrations',
                subtitle: 'Bookings and fees',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/camp-registrations',
            },
            {
                id: 'quotation',
                title: 'Quotation',
                subtitle: 'Quotes and expense heads',
                type: 'collapsable',
                icon: 'heroicons_outline:calculator',
                children: [
                    {
                        id: 'quotation.list',
                        title: 'Quotations',
                        type: 'basic',
                        icon: 'heroicons_outline:calculator',
                        link: '/quotations',
                    },
                    {
                        id: 'expense-heads',
                        title: 'Expense Heads',
                        type: 'basic',
                        icon: 'heroicons_outline:queue-list',
                        link: '/expense-heads',
                    },
                ],
            },
        ],
    },
    {
        id: 'participants',
        title: 'Participants',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/participants',
    },
    {
        id: 'inventory',
        title: 'Inventory',
        type: 'collapsable',
        icon: 'heroicons_outline:archive-box',
        children: [
            {
                id: 'inventory.items',
                title: 'Item Master',
                subtitle: 'Stock items',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/inventory/items',
            },
            {
                id: 'inventory.outward',
                title: 'Outward (Issue)',
                subtitle: 'Items given out',
                type: 'basic',
                icon: 'heroicons_outline:arrow-up-tray',
                link: '/inventory/outward',
            },
            {
                id: 'inventory.inward',
                title: 'Inward (Return)',
                subtitle: 'Items returned',
                type: 'basic',
                icon: 'heroicons_outline:arrow-down-tray',
                link: '/inventory/inward',
            },
            {
                id: 'inventory.payments',
                title: 'Payments',
                subtitle: 'Inventory payments',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/inventory/payments',
            },
        ],
    },
    {
        id: 'masters',
        title: 'Masters',
        type: 'collapsable',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id: 'organizations',
                title: 'Organizations',
                subtitle: 'Schools and groups',
                type: 'basic',
                icon: 'heroicons_outline:building-library',
                link: '/organizations',
            },
            {
                id: 'locations',
                title: 'Location',
                subtitle: 'Countries',
                type: 'collapsable',
                icon: 'heroicons_outline:map',
                children: [
                    {
                        id: 'countries',
                        title: 'Countries',
                        type: 'basic',
                        icon: 'heroicons_outline:flag',
                        link: '/countries',
                    },
                ],
            },
            {
                id: 'users',
                title: 'Users',
                subtitle: 'Staff and access',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/users',
            },
        ],
    },
    {
        id: 'messages',
        title: 'Messages',
        type: 'collapsable',
        icon: 'heroicons_outline:chat-bubble-left-right',
        children: [
            {
                id: 'chat',
                title: 'Chat',
                subtitle: 'Team conversations',
                type: 'basic',
                icon: 'heroicons_outline:chat-bubble-left-right',
                link: '/chat',
            },
            {
                id: 'whatsapp',
                title: 'WhatsApp',
                subtitle: 'Participant messages',
                type: 'basic',
                icon: 'heroicons_outline:chat-bubble-left-ellipsis',
                link: '/whatsapp',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    }
];
// The desktop menu shows the same top-level items; the mock API fills each
// item's children from defaultNavigation by id.
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation.map(
    ({ children, ...item }) => ({ ...item })
);
